import BaseComponent from '../abstracts/BaseComponent';
import { loggedInPromise } from './LoginComponent';

export default class WishlistComponent extends BaseComponent {

  get PATHNAME() {
    return this.$options.pathname || location.pathname;
  }

  constructor(element) {
    super(element);
    this.initElement();
  }

  initElement = element => {
    (element || this.$el).querySelectorAll('.js-wishlist').forEach(el => {
      el.removeEventListener('click', this.toggleFavourite);
      el.addEventListener('click', this.toggleFavourite);
    });
  }

  toggleFavourite = event => {
    // consoole.log('toggleFavourite');
    event.preventDefault();
    const currentTarget = event.currentTarget;

    loggedInPromise().then(response => {
      // consoole.log('response', response);

      if (!response) {
        return;
      }

      const item = currentTarget;
      const icon = currentTarget;
      const brand = currentTarget.dataset.brand;
      const remove = icon.classList.contains('icon-wish-on');
      fetch(`${this.PATHNAME}?favourite=true&async=true&brand=${brand}&remove=${remove}`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          Accept: 'application/json'
        }
      })
      .then(response => {
        if (response.status === 200) {
          // make sure the server returned true before changing the icon
          const success = response.json();
          return success;
        } else {
          throw new Error("Not 200 response");
        }
      })
      .then(success => {
        if (!success) {
          return;
        }

        icon.className = icon.className.replace(/icon-wish(-on)?/, `icon-wish${remove ? '' : '-on'}`);

        if (currentTarget.dataset.tracking) {
          currentTarget.dataset.tracking = currentTarget.dataset.tracking
              .replace(/^(add|remove)\b/, remove ? 'add' : 'remove');
        }
      });
    });
  }

}
